import types from './types';

const INITIAL_STATE = {
    isFetchingUnused: false,

    result: [],
};

const authUnusedReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_UNUSED_AUTH_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingUnused: true,
        };

    case types.GET_UNUSED_AUTH_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingUnused: false,
        };

    case types.GET_UNUSED_AUTH_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingUnused: false,
        };

    default:
      return state;
  }
};

export default authUnusedReducer;
